import GrowthRing from "@/components/visuals/GrowthRing";
import { Btn, Eyebrow } from "@/components/primitives";
import { brand, cta } from "@/content/site";
import { Reveal } from "@/components/motion/Reveal";

// Deep Forest final call-to-action band.
export default function CTASection({
  eyebrow = "Free Growth Assessment",
  heading = "What would change if your growth kept moving quietly in the background?",
  copy = "Book a free initial Growth Assessment. Tell us how your business operates today, where you want it to go and what keeps getting in the way.",
}) {
  return (
    <section
      data-testid="cta-section"
      className="relative bg-forest overflow-hidden py-24 md:py-32"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-32 -top-24 opacity-40"
      >
        <GrowthRing size={480} colorFrom="#2CD59C" colorTo="#8DFE3F" duration={90} />
      </div>
      <div className="relative mx-auto max-w-4xl px-5 sm:px-8 text-center">
        <Reveal>
          <Eyebrow dark className="justify-center">
            {eyebrow}
          </Eyebrow>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight leading-[1.1] text-white text-balance">
            {heading}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-lg text-white/75 leading-relaxed max-w-2xl mx-auto">
            {copy}
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Btn to={cta.primary.to} size="lg" data-testid="cta-primary-btn">
              {cta.primary.label}
            </Btn>
            <a
              href={`mailto:${brand.email}`}
              data-testid="cta-email-link"
              className="text-white/80 font-semibold hover:text-lime transition-colors"
            >
              {brand.email}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
